import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/zh.ts
var add = "添加";
var remove = "移除";
var removeAll = "移除全部";
var incomplete = "抱歉，部分字段未被正确填写。";
var submit = "提交";
var noFiles = "未选择文件";
var moveUp = "上移";
var moveDown = "下移";
var isLoading = "加载中...";
var loadMore = "加载更多";
var next = "下一步";
var prev = "上一步";
var addAllValues = "添加所有值";
var addSelectedValues = "添加所选值";
var removeAllValues = "移除所有值";
var removeSelectedValues = "移除所选值";
var chooseDate = "选择日期";
var changeDate = "更改日期";
var close = "关闭";
var open = "打开";
var accepted = function({
  name
}) {
  return `请接受${name}。`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)}必须晚于${date(args[0])}。`;
  }
  return `${sentence(name)}必须是未来的日期。`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)}只能包含英文字母。`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)}只能包含字母和数字。`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)}只能包含字母和空格。`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} 必须包含字母字符`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} 必须包含字母或数字。`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} 必须包含字母或空格。`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} 必须包含符号。`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} 必须包含大写字母。`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} 必须包含小写字母。`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} 必须包含数字。`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} 必须是符号。`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} 只能包含大写字母。`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} 只能包含小写字母。`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)}必须早于${date(args[0])}。`;
  }
  return `${sentence(name)}必须是过去的日期。`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `该字段未被正确设置而无法提交。`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)}必须在${a}和${b}之间。`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)}不匹配。`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)}不是合法日期，请使用 ${args[0]} 格式`;
  }
  return "该字段未被正确设置而无法提交";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)}必须在${date(args[0])}和${date(args[1])}之间`;
};
var email = "请输入合法的电子邮件地址。";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)}必须以${list(args)}结尾。`;
};
var is = function({
  name
}) {
  return `${sentence(name)}是不允许的。`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)}至少要有一个字符。`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)}必须少于或等于${max2}个字符。`;
  }
  if (min2 === max2) {
    return `${sentence(name)}必须包含${max2}个字符。`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)}必须多于或等于${min2}个字符。`;
  }
  return `${sentence(name)}必须介于${min2}和${max2}个字符之间。`;
};
var matches = function({
  name
}) {
  return `${sentence(name)}是不允许的。`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name}不得多于${args[0]}个值。`;
  }
  return `${name}不得大于${args[0]}。`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "没有允许的文件格式。";
  }
  return `${sentence(name)}的类型必须为：${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name}不得少于${args[0]}个值。`;
  }
  return `${sentence(name)}不得小于${args[0]}。`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `"${value}"不是一个合法的${name}。`;
};
var number = function({
  name
}) {
  return `${sentence(name)}必须为数字。`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join("或")}${labels}需要。`;
};
var required = function({
  name
}) {
  return `${sentence(name)}不得留空。`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)}必须以${list(args)}开头。`;
};
var url = function() {
  return `请输入有效的 URL。`;
};
var invalidDate = "所选日期无效。";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var zh_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, zh_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=zh.mjs.map